module.exports = require("mysql");